(() => {
  const mixModes = {
    hot: {
      label: 'HOT DRINK IDEAS',
      title: 'Make it part of the warm drinks you already enjoy.',
      copy: 'Unflavoured collagen can fit into familiar drinks from morning through evening.',
      examples: [
        'Coffee',
        'Tea',
        'Warm apple cider',
        'Matcha',
        'Hot chocolate'
      ]
    },
    cold: {
      label: 'COLD DRINK IDEAS',
      title: 'Keep it simple, chilled or blended.',
      copy: 'Use it in the cold drinks and blended favourites that already fit your day.',
      examples: [
        'Water',
        'Smoothies',
        'Milkshake',
        'Iced coffee',
        'Juice'
      ]
    },
    food: {
      label: 'SAVOURY FOOD IDEAS',
      title: 'Fold it into everyday meals from many traditions.',
      copy: 'The neutral format can fit into familiar savoury dishes without creating a separate supplement ritual.',
      examples: [
        'Soup',
        'Chili',
        'Curry',
        'Pasta',
        'Congee'
      ]
    }
  };

  const strawberryMixModes = {
    water: {
      label: 'SIMPLEST ROUTINE',
      title: 'Shake it into cold water and go.',
      copy: 'Real freeze-dried strawberries make the flavour light, bright and easy to recognize.',
      examples: ['Cold water', 'Ice water', 'Water bottle', 'Shaker cup']
    },
    smoothie: {
      label: 'SMOOTHIE IDEAS',
      title: 'Bring strawberry protein to a blended routine.',
      copy: 'Pair the real-fruit flavour with familiar smoothie ingredients you already enjoy.',
      examples: ['Banana smoothie', 'Berry smoothie', 'Mango smoothie', 'Yogurt smoothie']
    },
    mocktail: {
      label: 'COLD DRINK IDEAS',
      title: 'Turn it into a bright alcohol-free refresher.',
      copy: 'Keep the preparation simple and let the real strawberry flavour do the work.',
      examples: ['Sparkling water', 'Lemon water', 'Iced tea', 'Coconut water']
    }
  };

  const initCollagenPdp = (root) => {
    if (root.dataset.collagen2Ready === 'true') return;
    root.dataset.collagen2Ready = 'true';

    root.querySelectorAll('[data-collagen2-ingredient]').forEach((card) => {
      const button = card.querySelector('button');
      const detail = card.querySelector('.collagen2-ingredient-detail');
      if (!button || !detail) return;

      button.addEventListener('click', () => {
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(willOpen));
        detail.hidden = !willOpen;
        card.classList.toggle('is-open', willOpen);
      });
    });

    const mixer = root.querySelector('[data-collagen2-mixer]');
    if (mixer) {
      const availableMixModes = root.classList.contains('collagen2--strawberry') ? strawberryMixModes : mixModes;
      const stage = mixer.querySelector('[data-mix-stage]');
      const tabs = [...mixer.querySelectorAll('[data-mix-mode]')];
      const setMixMode = (mode) => {
        const content = availableMixModes[mode];
        if (!content || !stage) return;
        tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.mixMode === mode)));
        stage.dataset.mixStage = mode;
        stage.querySelector('[data-mix-label]').textContent = content.label;
        stage.querySelector('[data-mix-title]').textContent = content.title;
        stage.querySelector('[data-mix-copy]').textContent = content.copy;
        const examples = stage.querySelector('[data-mix-examples]');
        examples.replaceChildren(...content.examples.map((example) => {
          const item = document.createElement('li');
          item.textContent = example;
          return item;
        }));
      };
      tabs.forEach((tab) => tab.addEventListener('click', () => setMixMode(tab.dataset.mixMode)));
    }

    const dialog = root.querySelector('[data-collagen2-label-dialog]');
    const openDialog = root.querySelector('[data-collagen2-label-open]');
    const closeDialog = root.querySelector('[data-collagen2-label-close]');
    if (dialog && openDialog) {
      openDialog.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
      const close = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };
      if (closeDialog) closeDialog.addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
    }

    const sticky = root.querySelector('[data-collagen2-sticky]');
    const stickyButton = root.querySelector('[data-collagen2-sticky-submit]');
    const stickyPrice = sticky?.querySelector('span');
    const productForm = document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]');
    const nativeButton = productForm && productForm.querySelector('[type="submit"]');
    if (sticky && stickyButton && productForm && nativeButton) {
      const syncStickyPurchase = (detail = {}) => {
        if (stickyPrice && detail.stickyPrice) stickyPrice.textContent = detail.stickyPrice;
        if (detail.buttonText) stickyButton.textContent = detail.buttonText;
      };
      const heroRoot = document.querySelector('[data-c2hero-root]');
      if (heroRoot) {
        syncStickyPurchase({
          stickyPrice: heroRoot.dataset.c2heroStickyPrice,
          buttonText: heroRoot.dataset.c2heroStickyButton
        });
      }
      window.addEventListener('c2hero:purchase-change', (event) => syncStickyPurchase(event.detail));

      const footer = document.querySelector('footer, .shopify-section-group-footer-group');
      let purchasePassed = false;
      let footerVisible = false;
      const updateSticky = () => sticky.classList.toggle('is-visible', purchasePassed && !footerVisible && !nativeButton.disabled);

      const purchaseObserver = new IntersectionObserver(([entry]) => {
        purchasePassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        updateSticky();
      }, { threshold: 0.05 });
      purchaseObserver.observe(productForm);

      if (footer) {
        const footerObserver = new IntersectionObserver(([entry]) => {
          footerVisible = entry.isIntersecting;
          updateSticky();
        }, { threshold: 0.01 });
        footerObserver.observe(footer);
      }

      stickyButton.addEventListener('click', () => {
        if (!nativeButton.disabled) nativeButton.click();
      });
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-collagen2-root]').forEach(initCollagenPdp);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
